import { ComponentProps, FC } from 'react';
import { BoundTurnstileObject, useTurnstile } from 'react-turnstile';
import { CaftaTurnstile } from './CaftaTurnstile';
import { useFormContext } from 'react-hook-form-mui';

export const CaftaTurnstileField: FC<ComponentProps<typeof CaftaTurnstile>> = (
  props
) => {
  const { onVerify, ...rest } = props;
  const { setValue } = useFormContext();
  useTurnstile();

  const setTurnstileToken = (
    token: string,
    boundTurnstile: BoundTurnstileObject
  ) => {
    setValue('turnstileToken', token);

    onVerify?.(token, boundTurnstile);
  };

  return <CaftaTurnstile onVerify={setTurnstileToken} {...rest} />;
};
